import React from 'react'
import Button from '../../atoms/Button/Button'
import Link from 'next/link'

const StrumentiServiziCard = ({ index, strumento }) => {
  return (
    <div className={'strumenti-card' + (index % 2 ? ' strumenti-card--reversed' : '')}>
      <div className="strumenti-card__content">
        <span className="strumenti-card__index">{index + 1}</span>
        <p className="strumenti-card__title">{strumento.titolo}</p>
        <div
          className="strumenti-card__description"
          dangerouslySetInnerHTML={{
            __html: strumento.testo,
          }}
        ></div>
        {strumento.link && (
          <Link href={strumento.link}>
            <a className="strumenti-card__cta">
              <Button label={strumento.cta_link} size="large" variant="primary" />
            </a>
          </Link>
        )}
      </div>
      <div className={'strumenti-card__img-box'}>
        <img src={strumento.immagine_url} className={'strumenti-card__img'} />
        <div
          className="strumenti-card__caption"
          dangerouslySetInnerHTML={{
            __html: strumento.testo_box,
          }}
        ></div>
      </div>
    </div>
  )
}

export default StrumentiServiziCard
